import { render, staticRenderFns } from "./aLteLayoutLogin.vue?vue&type=template&id=2067232e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2067232e', component.options)
    } else {
      api.reload('2067232e', component.options)
    }
    module.hot.accept("./aLteLayoutLogin.vue?vue&type=template&id=2067232e", function () {
      api.rerender('2067232e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/aLteLayoutLogin.vue"
export default component.exports